import Loadable from 'react-loadable';

import LoadingPage from './components/LoadingPage';

export const AsyncRegistration = Loadable({
  loader: () => import('./containers/Registration'),
  loading: LoadingPage,
});

export const AsyncNotFound = Loadable({
  loader: () => import('./containers/NotFound'),
  loading: LoadingPage,
});



// WEBPACK FOOTER //
// ./src/RouteLoaders.jsx